import { render, staticRenderFns } from "./ghzTable.vue?vue&type=template&id=2a3ba11f&scoped=true"
import script from "./ghzTable.vue?vue&type=script&lang=ts"
export * from "./ghzTable.vue?vue&type=script&lang=ts"
import style0 from "./ghzTable.vue?vue&type=style&index=0&id=2a3ba11f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ba11f",
  null
  
)

export default component.exports